import { CounterIcon } from './CounterIcon';

/**
 * author: Christopher Schreiner
 * id F789F2E4-022E-4A5A-B548-30D21BC3A7F6
 * name counter
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/counter.svg
 * tags
 * - Automotive 
 */
export const OdometerIcon = CounterIcon;
export default OdometerIcon